import { getDomainState as getAuthState } from 'app/auth/selectors';
import type { AuthSlice } from 'app/auth/types';
import { getCurrentProjectId, type ProjectSlice } from 'app/project';
import createCachedSelector from 're-reselect';
import { createSelector } from 'reselect';
import { checkAccessPolicy, getAccessPolicy } from './util';

export const getPolicies = createSelector(getAuthState, (state) => (state.user ? state.user.get('policies') : null));

export const selectAccessPolicy = createSelector(getPolicies, (policies) => {
  return getAccessPolicy(policies ? policies.toJS() : []);
});

export type PermissionsSlice = AuthSlice & ProjectSlice;
export type PermissionsProps = {
  action: string;
  resource: string;
};

const getAction = (state: unknown, props: PermissionsProps): string => props.action;
const getResource = (state: unknown, props: PermissionsProps): string => props.resource;

export function createGetPermission(
  checkAccessFunction: typeof checkAccessPolicy
): (state: PermissionsSlice, props: PermissionsProps) => boolean {
  return createCachedSelector(
    [selectAccessPolicy, getCurrentProjectId, getResource, getAction],
    (accessPolicy, projectId, resource, action) => {
      const formattedResource = resource.replace('{projectId}', projectId);
      return checkAccessFunction(accessPolicy, action, formattedResource);
    }
  )((state, props) => {
    const projectId = getCurrentProjectId(state);
    return `${props.action}|${props.resource}|${projectId}`;
  });
}

export const getPermission = createGetPermission(checkAccessPolicy);
